var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/divider/divider.tsx";
import React from 'react';
/** Divider */
const Divider = ({
  text
}) => /*#__PURE__*/React.createElement("div", {
  className: "relative",
  "data-testid": "divider",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 9,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "absolute inset-0 flex items-center",
  "aria-hidden": "true",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 10,
    columnNumber: 5
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "w-full border-t-2 border-gray-100 dark:border-slate-700 border-solid",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 7
  }
})), text && /*#__PURE__*/React.createElement("div", {
  className: "relative flex justify-center",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 15,
    columnNumber: 7
  }
}, /*#__PURE__*/React.createElement("span", {
  className: "px-2 bg-white text-gray-400",
  "data-testid": "divider-text",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 16,
    columnNumber: 9
  }
}, text)));
export default Divider;